export const user = [
    {name:'BIGAPPLECAR BIG' ,user:'bigapplecar_big'  ,password:'JLu9y3tS',role:1},
    {name:'BIGAPPLECAR APPLE' ,user:'bigapplecar_apple'  ,password:'Kzf307tF',role:1},
    {name:'BIGAPPLECAR MEMEE' ,user:'bigapplecar_memee'  ,password:'AceM604v',role:1},
    {name:'BIGAPPLECAR TEE' ,user:'bigapplecar_tee'  ,password:'LUDI1Pac',role:2},
    {name:'BIGAPPLECAR KIK' ,user:'bigapplecar_kik'  ,password:'O3X6cpXu',role:2},
    {name:'BIGAPPLECAR SALES' ,user:'bigapplecar_sales'  ,password:'YI5uEi2J',role:3},
]